import { RadioCard } from "@/components/PreferenceCard";

interface YesNoFieldProps {
  label: string;
  value: "yes" | "no" | undefined;
  onChange: (value: "yes" | "no") => void;
  error?: string;
  /** Shows the required asterisk, like FieldLabel. */
  required?: boolean;
}

/** A Yes/No pair of RadioCards, for single-select boolean-style preference questions. */
export const YesNoField = ({ label, value, onChange, error, required }: YesNoFieldProps) => (
  <div data-field className="flex flex-col gap-2">
    <label className="label">
      {label}
      {required && <span className="text-required-star ml-0.5">*</span>}
    </label>
    <div className="grid grid-cols-2 gap-3">
      <RadioCard selected={value === "yes"} onSelect={() => onChange("yes")} label="Yes" />
      <RadioCard selected={value === "no"} onSelect={() => onChange("no")} label="No" />
    </div>
    {error && (
      <p data-field-error className="error-message">
        {error}
      </p>
    )}
  </div>
);
